import { createI18n } from "vue-i18n";

export const fallbackMessages = {
  en: {
    message: {
      UNAUTHORIZED_USER: "You are not authorized to access this portal.",
      DATA_SHEET_MANUAL: "Data sheet / Manual",
      SHAREPOINT_URL: "SharePoint URL",
      ENTER_SHAREPOINT_URL: "Enter SharePoint or external URL",
      UPLOAD_PDF: "Upload PDF",
      ONLY_PDF_ALLOWED: "Only PDF files are allowed",
      PDF_MAX_5MB: "PDF file must be 5MB or less",
      SOMETHING_WENT_WRONG: "Something went wrong",
      CUSTOMERS_SYNCING_STARTED: "Customer syncing started",
      BUSINESS_CENTRAL_ERROR: "Business Central Error",
      BUSINESS_CENTRAL_API_POST_ERROR: "Business Central API POST error",
      NOTE: "Note",
      PO_NUMBER: "PO Number",
      DELIVERY_INSTRUCTION: "Delivery Instruction"
    }
  },
  da: {
    message: {
      UNAUTHORIZED_USER: "Du har ikke adgang til denne portal.",
      DATA_SHEET_MANUAL: "Datablad / Manual",
      SHAREPOINT_URL: "SharePoint-URL",
      ENTER_SHAREPOINT_URL: "Indtast SharePoint eller ekstern URL",
      UPLOAD_PDF: "Upload PDF",
      ONLY_PDF_ALLOWED: "Kun PDF-filer er tilladt",
      PDF_MAX_5MB: "PDF-filen må højst være 5MB",
      SOMETHING_WENT_WRONG: "Noget gik galt",
      CUSTOMERS_SYNCING_STARTED: "Kundesynkronisering er startet",
      BUSINESS_CENTRAL_ERROR: "Business Central-fejl",
      BUSINESS_CENTRAL_API_POST_ERROR: "Business Central API POST-fejl",
      NOTE: "Note",
      PO_NUMBER: "PO-nummer",
      DELIVERY_INSTRUCTION: "Leveringsinstruktion"
    }
  }
};

const messages = {
  en: fallbackMessages.en,
  da: fallbackMessages.da
};

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  fallbackWarn: false,
  missingWarn: false,
  messages
});

export default i18n;
